module.exports = __webpack_public_path__ + "static/media/studies.c42ea514.svg";